import Chart from 'chart.js';
import 'chartjs-adapter-date-fns';
import 'chartjs-plugin-annotation';

Chart.defaults.global.defaultFontFamily = 'Montserrat';
Chart.defaults.global.defaultFontColor = '#1C2548';
